export var Platform;
(function (Platform) {
    Platform[Platform["MEITUAN"] = 1] = "MEITUAN";
    // 美团
    Platform[Platform["DIANPING"] = 2] = "DIANPING"; // 点评
})(Platform || (Platform = {}));
export var Source;
(function (Source) {
    Source[Source["MEITUAN_APP"] = 1] = "MEITUAN_APP";
    // 美团APP
    Source[Source["DIANPING_APP"] = 2] = "DIANPING_APP";
    // 点评APP
    Source[Source["WECHAT_MEITUAN_MINI"] = 3] = "WECHAT_MEITUAN_MINI";
    // 微信美团小程序
    Source[Source["WECHAT_HOTEL_MINI"] = 4] = "WECHAT_HOTEL_MINI";
    // 微信酒店+小程序
    Source[Source["WECHAT_DIANPING_MINI"] = 5] = "WECHAT_DIANPING_MINI"; // 微信点评小程序
})(Source || (Source = {}));
export const LOCATION_SCENE_TOKEN = 'dd-9cbc1c31cfbf2bba';
export var CouponStatus;
(function (CouponStatus) {
    CouponStatus[CouponStatus["NotClaimed"] = 1] = "NotClaimed";
    // 可领取
    CouponStatus[CouponStatus["InVaild"] = 2] = "InVaild";
    // 不可领取
    CouponStatus[CouponStatus["ToUse"] = 3] = "ToUse";
    // 已领取未使用
    CouponStatus[CouponStatus["Used"] = 4] = "Used";
    // 已使用
    CouponStatus[CouponStatus["Expired"] = 5] = "Expired";
    // 已过期
    CouponStatus[CouponStatus["Already"] = 6] = "Already";
    // 预先领取
    CouponStatus[CouponStatus["Claimed"] = 7] = "Claimed"; // 已领取
})(CouponStatus || (CouponStatus = {}));
export const TYPE_MAP = {
    [CouponStatus.NotClaimed]: 1,
    [CouponStatus.InVaild]: -1,
    [CouponStatus.ToUse]: 2,
    [CouponStatus.Used]: 4,
    [CouponStatus.Expired]: 3,
    [CouponStatus.Already]: 2,
    [CouponStatus.Claimed]: 2
};
export const FLASH_TYPE_MAP = {
    [CouponStatus.NotClaimed]: 6,
    [CouponStatus.InVaild]: -1,
    [CouponStatus.ToUse]: 7,
    [CouponStatus.Used]: 9,
    [CouponStatus.Expired]: 3,
    [CouponStatus.Already]: 7,
    [CouponStatus.Claimed]: 7
};
export var CannotCode;
(function (CannotCode) {
    CannotCode[CannotCode["Empty"] = 120001] = "Empty"; // 库存不足
})(CannotCode || (CannotCode = {}));
export var BizLine;
(function (BizLine) {
    BizLine[BizLine["hotel"] = 1] = "hotel";
    // 境内住宿酒店券
    BizLine[BizLine["air"] = 2] = "air";
    //机票
    BizLine[BizLine["train"] = 3] = "train";
    // 火车票
    BizLine[BizLine["ticket"] = 5] = "ticket";
    // 景点门票
    BizLine[BizLine["vacation"] = 6] = "vacation"; // 度假
})(BizLine || (BizLine = {}));
export const BIZ_MAP = {
    [BizLine.hotel]: '酒店',
    [BizLine.air]: '机票',
    [BizLine.train]: '火车票',
    [BizLine.ticket]: '门票',
    [BizLine.vacation]: '度假'
};
export var TimeSlotSatus;
(function (TimeSlotSatus) {
    TimeSlotSatus[TimeSlotSatus["NotStart"] = 1] = "NotStart";
    // 未开抢
    TimeSlotSatus[TimeSlotSatus["InProgress"] = 2] = "InProgress";
    // 进行中
    TimeSlotSatus[TimeSlotSatus["End"] = 3] = "End"; // 已过期
})(TimeSlotSatus || (TimeSlotSatus = {}));
export const TSS_MAP = {
    [TimeSlotSatus.NotStart]: '开抢提醒',
    [TimeSlotSatus.InProgress]: '进行中',
    [TimeSlotSatus.End]: '已过期'
};
export const arrIconUrl = 'https://img.meituan.net/makerjiulv/c9efff07af8f247a253fe1eaa568d6d8440.png';
